import { useState } from 'react'
import { ConfirmDialog } from './Dialog.js'
import { AuthAnimatedBackground } from './AuthAnimatedBackground.js'

/**
 * Vitrine du PREMIER DIALOGUE du design system — la référence gelée.
 *
 * Le cas retenu : « Régénérer les codes de secours ? » (action destructive :
 * les anciens codes meurent). L'usage réel arrivera avec l'écran Paramètres →
 * Sécurité (LOT 4) ; cette route ne sert qu'à la revue visuelle.
 */
export function DialogShowcase() {
  const [open, setOpen] = useState(true)
  const r = document.documentElement
  r.setAttribute('data-intensity', 'premium')
  if (!r.getAttribute('data-theme')) r.setAttribute('data-theme', 'dark')

  return (
    <>
      <div className="lc-bg" aria-hidden="true">
        <div className="lc-bg__wash-a" />
        <div className="lc-bg__wash-b" />
        <div className="lc-bg__spot" />
        <AuthAnimatedBackground />
      </div>
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <button className="lc-btn lc-btn--primary" onClick={() => setOpen(true)}>
          Ouvrir le dialogue de référence
        </button>
      </div>
      <ConfirmDialog
        open={open}
        danger
        title="Régénérer les codes de secours ?"
        confirmLabel="Régénérer"
        onConfirm={() => setOpen(false)}
        onClose={() => setOpen(false)}
      >
        Vos dix codes actuels cesseront immédiatement de fonctionner, y compris
        ceux que vous n’avez jamais utilisés. Dix nouveaux codes vous seront
        présentés — une seule fois.
      </ConfirmDialog>
    </>
  )
}
